__turbopack_context__.v({
  "content": "PlasmicFooter-module__t6Wphq__content",
  "desktopVer": "PlasmicFooter-module__t6Wphq__desktopVer",
  "desktopVergray": "PlasmicFooter-module__t6Wphq__desktopVergray",
  "footer": "PlasmicFooter-module__t6Wphq__footer",
  "footerBottom___9Pav": "PlasmicFooter-module__t6Wphq__footerBottom___9Pav",
  "footerBottom__h0Voo": "PlasmicFooter-module__t6Wphq__footerBottom__h0Voo",
  "footerBottom__yNlit": "PlasmicFooter-module__t6Wphq__footerBottom__yNlit",
  "footerTop___3Rx77": "PlasmicFooter-module__t6Wphq__footerTop___3Rx77",
  "footerTop__lxFnc": "PlasmicFooter-module__t6Wphq__footerTop__lxFnc",
  "footerTop__v1Owx": "PlasmicFooter-module__t6Wphq__footerTop__v1Owx",
  "footergray": "PlasmicFooter-module__t6Wphq__footergray",
  "mobileVer": "PlasmicFooter-module__t6Wphq__mobileVer",
  "mobileVergray": "PlasmicFooter-module__t6Wphq__mobileVergray",
  "tabletVer": "PlasmicFooter-module__t6Wphq__tabletVer",
  "tabletVergray": "PlasmicFooter-module__t6Wphq__tabletVergray",
});
